var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MarkingsListItem',{attrs:{"hide-actions":"","disable-elements-with-parents":"","item":_vm.item,"parents-list":[],"full-disabled":_vm.fullDisabled,"disabled":_vm.disabled},on:{"select-item":function($event){return _vm.$emit('select-item', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }